export const ENVIRONMENT_HEADER = 'x-mapp-environment';
